import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import QuestionMarkButton from '../../QuestionMarkButton';

type WrapperProps = {
  disabled?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 288px;
  min-height: 44px;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `};

  @media (max-width: ${device.mobileS}) {
    width: 293px;
  }
`;

export const Label = styled.div`
  color: #777e91;
  font-size: 12px;
  font-family: Poppins-Regular, sans-serif;
  margin: 0 auto 6px 0;
  text-transform: uppercase;

  .tooltip {
    margin-left: 5px;
  }
`;

export const TooltipTrigger = styled.div`
  position: relative;
  //z-index: 2;
  padding-left: 8px;
`;

export const FieldQuestionMarkButton = styled(QuestionMarkButton)`
  height: 22px;
  width: 22px;

  & > img {
    width: 100%;
    height: 100%;
  }

  &:active {
    opacity: 0.8;
  }
`;
